module.exports = __webpack_public_path__ + "img/AnalysisScreenShot2.12f1ae30.png";